import { quSave } from '@/service/question'
import util from '@/tools/commonUtil'
import iconSrc from '@/assets/images/edit/config/ico-radio@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  orderById: 30,
  elementType: 'RadioBox',
  elementDesc: '单选题',
  type: 'radiobox',
  // 是否可配置
  config: true,
  title: '单选题',
  placeholder: '选项',
  isRequired: '1',
  quoteQuId: '',
  answerType: '',
  // 最大长度
  maxLength: 20,
  itemName: 'optionList',
  // 选项内数据
  optionList: [{
    orderById: '1',
    optionName: '',
    type: 'normal',
    quoteQuId: '',
    answerType: '',
    imgUrl: '',
    imgName: ''
  }, {
    orderById: '2',
    optionName: '',
    type: 'normal',
    quoteQuId: '',
    answerType: '',
    imgUrl: '',
    imgName: ''
  }],
  vertical: true,
  value: '',
  ruleError: '该字段不能为空',
  // 带mediaQuType的组件的拓展提示
  tipsVote: '票',
  // 选项随机排列   0顺序排列1随机排列2循环显示
  randOrder: '0',
  saveUrl: '/design/qu-radio/ajaxSave.do',
  iconStyle: {
    width: '12px',
    height: '12px',
    background: 'url(' + iconSrc + ')'
  },
  surveyColor: '',
  ifOpenGroup: false, // 是否开启分组
  optionGroupList: [],
  saveFn () {
    return quSave({
      optionList: util.genList(this.optionList)
    }, this)
  },
  saveCb (data) {
    this.optionList = util.genRetList.call(this, data.optionList, 'option', {
      otherValue: ''
    })
    this.answerType = data.answerType
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      quItemId: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/RadioBox/config.js